import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import loader from '@monaco-editor/loader';

// Suppress a Monaco 0.52.x bug: caretRangeFromPoint() returns null when the
// mouse exits the editor during text selection. Monaco rethrows the error in a
// setTimeout which would otherwise trigger CRA's error overlay in dev mode.
window.addEventListener('error', (event) => {
  if (event?.message?.includes('offsetNode')) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true); // capture phase — runs before react-error-overlay listener

// In production, use self-hosted Monaco files (copied to public/vs during Docker build).
// In development, fall back to the CDN default so the editor works without a build step.
if (process.env.NODE_ENV !== 'development') {
  loader.config({ paths: { vs: '/vs' } });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
